<template>
    <academic>
        <card-header :title="'Subject: '+subject.title+' - '+subject.code" />
        <div class="grid grid-cols-2 gap-4">
            <div class="p-6 bg-white border-b border-gray-200 overflow-y-scroll h-screen-80 shadow-sm sm:rounded-lg">
                <p class="text-lg font-medium mb-4">List Topics</p>
                <nested-draggable :subs="arrangeTopics.topics" :subject="subject.id" @changed="saveTopics()" />
<!--                <breeze-button v-if="arrangeTopics.topics.length" class="mt-4" @click="saveTopics">Save</breeze-button>-->
                <span v-if="arrangeTopics.recentlySuccessful" class="text-green-500 mx-4">Changes saved!</span>
            </div>
            <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg">
                <loading :showLoading="form.processing" />
                <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                    <p class="text-lg font-medium mb-4">Add Topic</p>
                    <!-- <form @submit.prevent="form.post(route('catalog.category.store'))"> -->
                    <form @submit.prevent="submitForm">
                        <div class="grid grid-cols-8 gap-4 mb-8">
                            <div class="col-span-8 sm:col-span-8">
                                <breeze-label :required="true" :value="'Title'"/>
                                <breeze-input required v-model="form.title" class="w-full"/>
                                <breeze-input-error :message="form.errors?form.errors.title:''" />
                            </div>
                            <div class="col-span-2 sm:col-span-2">
                                <breeze-label :required="true" :value="'Payout'"/>
                                <breeze-input required type="number" step="0.01" v-model="form.payout" class="w-full"/>
                                <breeze-input-error :message="form.errors?form.errors.payout:''" />
                            </div>
                            <div class="col-span-6 sm:col-span-6">
                                <!-- <breeze-label :value="'Parent Topic'"/>
                                <select-list :options="allTopics" :placeholder="'Select parent topic'" v-model="form.parent"></select-list>
                                <breeze-input-error :message="form.errors?form.errors.status:''" /> -->

                                <FormMultiselect
                                    label="Parent Topic"
                                    :options="allTopics"
                                    track-key="title"
                                    label-key="title"
                                    :object="true"
                                    v-model="form.parent"
                                    :placeholder="'Select parent topic'"
                                    :error="form.errors.parent"
                                    />
                            </div>
                            <div class="col-span-2 sm:col-span-2">
                                <breeze-label :value="'Theory'"/>
                                <breeze-checkbox type="checkbox" name="type" value="theory" v-model="form.is_theory" />
                                <breeze-input-error :message="form.errors?form.errors.is_theory:''" />
                            </div>
                            <div class="col-span-2 sm:col-span-2">
                                <breeze-label :value="'Practical'"/>
                                <breeze-checkbox type="checkbox" name="type" value="practical" v-model="form.is_practical" />
                                <breeze-input-error :message="form.errors?form.errors.is_practical:''" />
                            </div>
                            <div class="col-span-2 sm:col-span-2">
                                <breeze-label :value="'Software'"/>
                                <breeze-checkbox type="checkbox" name="type" value="software" v-model="form.is_software" />
                                <breeze-input-error :message="form.errors?form.errors.is_software:''" />
                            </div>
                            <div class="col-span-2 sm:col-span-2">
                                <breeze-label :value="'Site Visit'"/>
                                <breeze-checkbox type="checkbox" name="type" value="sitevisit" v-model="form.is_site_visit" />
                                <breeze-input-error :message="form.errors?form.errors.is_site_visit:''" />
                            </div>
                            <div class="col-span-2 sm:col-span-2">
                                <breeze-label :value="'Status'"/>
                                <breeze-checkbox v-model="form.status" :checked="form.status"/>
                                <breeze-input-error :message="form.errors?form.errors.status:''" />
                            </div>

                        </div>
                        <breeze-button :disabled="form.processing">Submit</breeze-button>
                        <span v-if="form.recentlySuccessful" class="text-green-500 mx-4">Topic Added!</span>
                        <exception />
                    </form>
                </div>
            </div>
        </div>
    </academic>
</template>

<script>
    import Academic from '@/Pages/Academic/Academic'
    import BreezeInput from '@/Components/Input'
    import BreezeLabel from '@/Components/Label'
    import ButtonLink from '@/Components/ButtonLink'
    import CardHeader from '@/Components/CardHeader'
    import { useForm } from '@inertiajs/inertia-vue3'
    import BreezeInputError from '@/Components/InputError'
    import BreezeButton from '@/Components/Button'
    import BreezeCheckbox from '@/Components/Checkbox'
    import Loading from '@/Components/Loading'
    import Exception from '@/Components/Exception'
    import SelectList from '@/Components/SelectList'
    import nestedDraggable from '@/Components/Nested'
    import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";

    export default {
        components: {
            FormMultiselect,
            Academic,
            BreezeInput,
            BreezeLabel,
            ButtonLink,
            CardHeader,
            BreezeInputError,
            BreezeButton,
            BreezeCheckbox,
            Loading,
            Exception,
            nestedDraggable,
            SelectList
        },
        props:['topics','subject','allTopics'],
        data(){
            return{
                form: useForm({
                    title: '',
                    payout: '',
                    parent: '',
                    is_theory: '',
                    is_practical: '',
                    is_software: '',
                    is_site_visit: '',
                    status: true,
                }),
                arrangeTopics: useForm({
                    topics: this.topics
                }),
            }
        },
        methods:{
            submitForm() {
                this.form.post(route('academic.subject.topic.store',this.subject.id),{
                    preserveScroll: true,
                    onSuccess: () => {this.form.reset(); location.reload()},
                });
            },
            saveTopics(){
                console.log('changed');
                this.arrangeTopics.post(route('academic.subject.topic.rearrange',this.subject.id),{
                    preserveScroll: true,
                });
            }
        }
    }
</script>
